import { Grid, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../common/Theme/Colors";
import {
  StyledCard,
  StyledTypography,
} from "../../../common/Utils/StyledComponents";
import { showToast } from "../../../common/Utils/ToastMessage";
import { useLazyGetReportedByMeRequestDataQuery } from "../../../request/ManageTaskFilters/ReportedByMeTask";
import {
  useCriticalTaskMutation,
  usePinTaskMutation,
} from "../../../request/Task";
import Translate from "../../../translation/utils/translateFunction";
import ListView from "../../ListView";
import { MarkCriticalAndPinTask } from "../Components/utils";
import { SUBTASK_PREFIX } from "../constants";
import { getReportedByMeTaskColumns } from "./Components/column.data";

const ReportedByMeTaskListing = ({ fixNavbar }) => {
  const { isRtl } = useSelector((state) => state.formanagement);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [lastPage, setLastPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reportedByMeData, setReportedByMeData] = useState([]);

  const [
    fetchReportedByMeList,
    {
      data: reportedByMeList,
      isLoading: isReportedByMeLoading,
      isError: isReportedByMeError,
      error: reportedByMeError,
      isFetching: isReportedByMeFetching,
    },
  ] = useLazyGetReportedByMeRequestDataQuery();

  const [pinTask, { data: pinTaskData }] = usePinTaskMutation({
    fixedCacheKey: "pinnedTask",
  });

  const [markCritical, { data: markCriticalData }] = useCriticalTaskMutation({
    fixedCacheKey: "criticalTask",
  });

  useEffect(() => {
    setIsLoading(true);
    fetchReportedByMeList(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pinTaskData, markCriticalData]);

  useEffect(() => {
    if (reportedByMeList?.nodes) {
      const { nodes, pageInfo } = reportedByMeList;
      setReportedByMeData(nodes);
      setLastPage(pageInfo.lastPageNo);
      setIsLoading(false);
    }
    if (reportedByMeError && isReportedByMeError) {
      showToast({
        message:
          JSON.stringify(reportedByMeError.data) ||
          Translate("common:unknownServerError"),
        type: "error",
      });
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportedByMeList, reportedByMeError]);

  const CustomSrCellRender = (params) => {
    return (
      <StyledTypography component="span" sx={{ color: colors.primary_009 }}>
        {params?.api?.getRowIndexRelativeToVisibleRows(params?.row?._id) +
          1 +
          (currentPage - 1) * 10}
      </StyledTypography>
    );
  };

  const CustomActionCellRender = (params) => {
    const { taskNumber } = params?.row;
    const isSubtask = taskNumber?.startsWith(SUBTASK_PREFIX);
    return (
      <div className="headerMargin">
        <a
          href="/#"
          className="nav-link dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v manageIconColor" />
        </a>
        <div className="dropdown-menu dropdownAlignment dropdownIconMenu">
          <MarkCriticalAndPinTask
            taskId={params?.row?.taskId || params?.row?._id}
            isPinnedEnabled={params?.row?.isPinnedEnabled}
            isMarkCriticalEnabled={params?.row?.isMarkAsCriticalEnabled}
            hasFlagged={params?.row?.hasFlagged}
            hasPinned={params?.row?.hasPinned}
            markAsCritical={markCritical}
            pinTask={pinTask}
          />
          <div
            className="manageIconColor ml-3 cursor-pointer dropdown-item"
            onClick={() =>
              navigate(isSubtask ? "/subtask/view" : "/taskDetails", {
                state: {
                  taskId: params?.row?._id,
                  isTaskFilter: true,
                  navigateFrom: "/reportedByMeTask",
                },
              })
            }
          >
            <span className="manageIconColor fa fa-eye" />
            {Translate("manageTask:viewTask")}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Grid
      item
      xs={12}
      className={`section-body ${isRtl ? "rtlMargin" : "ltrMargin"} ${
        fixNavbar ? "marginTop" : ""
      } `}
    >
      <StyledCard variant="outlined">
        <div className="container-fluid p-4">
          <div className="tab-content">
            <div>
              <div className="card">
                <div className="card-header card-header-spacing formTitle">
                  <Stack flexDirection={"row"} alignItems={"center"}>
                    <i
                      className="icon fe fe-arrow-left mr-3 icon-size backnavigation-iconColor cursor-pointer"
                      onClick={() => navigate("/manageTask")}
                      title={Translate("common:backToolTip")}
                    />
                    <h5 className="page-title">
                      {Translate("manageTask:reportByMe")}
                    </h5>
                  </Stack>
                </div>
                <div className="card-body">
                  <ListView
                    columns={getReportedByMeTaskColumns(
                      CustomSrCellRender,
                      CustomActionCellRender
                    )}
                    rows={reportedByMeData}
                    autoHeight
                    onPaginationChange={setCurrentPage}
                    currentPage={currentPage}
                    showShimmer={isReportedByMeFetching}
                    showLoader={isLoading || isReportedByMeLoading}
                    totalPageCount={lastPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyledCard>
    </Grid>
  );
};
export default ReportedByMeTaskListing;
